import { packIntoFormData } from "../utilities/apiUtilities";
import axiosInstance from "../auth/axioInstance";

const controllerUrl = `/discipline`

function createDiscipline(disciplineCreateViewModel) {
    return axiosInstance.post(`${controllerUrl}`, packIntoFormData(disciplineCreateViewModel), { headers: { 'Content-Type': "multipart/form-data"} });
}

function indexDisciplines({
    sortOrder = "", 
    searchString = "", 
    pageSize = 50, 
    pageNumber = 1
}) {
    return axiosInstance.get(`${controllerUrl}`, { params: {sortOrder: sortOrder, searchString: searchString, pageSize: pageSize, pageNumber: pageNumber}});
}

function getDiscipline(id) {
    return axiosInstance.get(`${controllerUrl}/${id}`);
}

function updateDiscipline(id, disciplineCreateViewModel) {
    return axiosInstance.put(`${controllerUrl}/${id}`, packIntoFormData(disciplineCreateViewModel), { headers: { 'Content-Type': "multipart/form-data"} });
}

function deleteDiscipline(id) {
    return axiosInstance.delete(`${controllerUrl}/${id}`);
}

export const disciplineService = {
    createDiscipline,
    indexDisciplines,
    getDiscipline,
    updateDiscipline,
    deleteDiscipline
}